import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { 
  Typography, 
  FormControl, 
  RadioGroup, 
  FormControlLabel, 
  Radio, 
  Paper, 
  Grid 
} from '@material-ui/core';
import { coloresEmma, consulta } from '../../global/js/funciones';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(3),
    color: coloresEmma.primarycolor,
  },
  fechaItem: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: '10px',
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
  },
  selectedFecha: {
    backgroundColor: '#e3f2fd',
    borderLeft: `4px solid ${coloresEmma.primarycolor}`,
  },
  horaInfo: {
    marginTop: theme.spacing(1),
  },
  noDisponible: {
    color: theme.palette.text.disabled,
    fontStyle: 'italic',
  }
}));

export default function SolicitudesAgendarCita({ props_c }) {
  const classes = useStyles();
  const [selectedCita, setSelectedCita] = useState('');
  const [disponibilidad, setDisponibilidad] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);



  useEffect(() => {
    let isMounted = true;
    
    const cargarDisponibilidad = async () => {
      if (!isMounted) return;
      
      setCargando(true);
      setError(null);
      
      try {
        const disponibilidadData = await new Promise((resolve, reject) => {
          consulta('api/v1.0/consultoria/disponibilidad/listar', null, null, (error, estado, resp) => {
            if (error) {
              reject(new Error('Error de conexión'));
              return;
            }
            
            if (estado === 200 && resp && Array.isArray(resp)) {
              const disponibilidadTransformada = resp.map(item => ({
                id: item.id ? item.id.toString() : Math.random().toString(),
                fecha: item.fecha || '',
                horaInicio: item.horaInicio || '',
                horaFin: item.horaFin || '',
                estudiante_consultoria: item.estudiante_consultoria || 'No asignado',
                estudiante_id: item.estudiante_id || null,
                estado: item.estado || 'disponible'
              }));
              
              resolve(disponibilidadTransformada);
            } else {
              resolve([]);
            }
          });
        });
        
        if (isMounted) {
          setDisponibilidad(disponibilidadData);
        }
      } catch (error) {
        console.error('Error al obtener disponibilidad:', error);
        if (isMounted) {
          setError('Error al cargar la disponibilidad. Por favor, intenta nuevamente.');
        }
      } finally {
        if (isMounted) {
          setCargando(false);
        }
      }
    };
    
    cargarDisponibilidad();
    
    return () => {
      isMounted = false;
    };
  }, []);



  const handleChange = (event) => {
    setSelectedCita(event.target.value);
    
    // Actualizar el estado en el componente padre si es necesario
    if (props_c && props_c.actualizarCita) {
      const citaSeleccionada = disponibilidad.find(cita => cita.id === event.target.value);
      props_c.actualizarCita(citaSeleccionada);
    }
  };

  // Función para formatear la fecha
  const formatearFecha = (fechaStr) => {
    const [year, month, day] = fechaStr.split('-');
    const fecha = new Date(year, month - 1, day); // Mes empieza en 0
    const opciones = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return fecha.toLocaleDateString('es-ES', opciones);
  };


  // Agrupar citas por fecha
  const citasPorFecha = disponibilidad.reduce((acc, cita) => {
    if (!acc[cita.fecha]) {
      acc[cita.fecha] = [];
    }
    acc[cita.fecha].push(cita);
    return acc;
  }, {});

  return (
    <div className={classes.root}>
      <Typography variant="h6" className={classes.title}>
        Agenda tu cita
      </Typography>
      
      {cargando ? (
        <Typography>
          Cargando horarios disponibles...
        </Typography>
      ) : error ? (
        <Typography className={classes.noDisponible}>
          {error}
        </Typography>
      ) : disponibilidad.length === 0 ? (
        <Typography className={classes.noDisponible}>
          No hay horarios disponibles en este momento.
        </Typography>
      ) : (
        <FormControl component="fieldset">
          <RadioGroup 
            aria-label="citas" 
            name="citas" 
            value={selectedCita} 
            onChange={handleChange}
          >
            {Object.entries(citasPorFecha).map(([fecha, citas]) => (
              <div key={fecha}>
                <Typography variant="subtitle1" gutterBottom>
                  {formatearFecha(fecha)}
                </Typography>
                
                {citas.map((cita) => (
                  <Paper 
                    key={cita.id} 
                    className={`${classes.fechaItem} ${selectedCita === cita.id ? classes.selectedFecha : ''}`}
                    elevation={1}
                  >
                    <FormControlLabel
                      value={cita.id}
                      control={<Radio color="primary" />}
                      label={
                        <Grid container direction="column">
                          <Typography variant="body1">
                            Horario: {cita.horaInicio} - {cita.horaFin}
                          </Typography>
                          <Typography variant="body2" className={classes.horaInfo} color="textSecondary">
                            Consultor: {cita.estudiante_consultoria}
                          </Typography>
                          <Typography variant="body2" className={classes.horaInfo} color="textSecondary">
                            Duración: 1 hora
                          </Typography>
                        </Grid>
                      }
                    />
                  </Paper>
                ))}
              </div>
            ))}
          </RadioGroup>
        </FormControl>
      )}
    </div>
  );
}